// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"289":"f2295e87","787":"68f85b73"}[chunkId] + ".chunk.js";
};